module.exports = __webpack_public_path__ + "static/media/CentraleSansCndBook.236f7c6b.woff";